// The version of the walls the town is sent: public/models/obstacles.glb,
// the blockers of the things he asked for (lib/world/wants.js), the
// monorail's pylons (lib/world/monorail.js) and the laundrette's walls
// (lib/world/laundrette.js), which the viewer ships to the town together on
// connect (ServerNPCBridge).
//
// The town keeps the first set it is sent and, until 30 Oct, nothing could
// replace it but a restart. A deploy restarts it while tabs still open on
// the old site reconnect first and send the old walls: on 30 Oct the live
// town took the old 159 boxes after the deploy that gave the containers
// and the tube carriage their insides, and he could neither rest in a
// container nor stay out of the carriage's sides until the set was
// reloaded by hand. So the site says which version it sends, the town is
// built from the same commit and knows the current one, and a set of the
// current version replaces one that is not (ServerObstacles.offerWalls).
//
// test/walls.test.js holds the hashes: change obstacles.glb, a want's
// blockers, the monorail's pylons, the walls at its station or the laundrette's walls and it fails
// until `version` is raised and the hashes updated.
//
// It lives under sim-server/ because Render rebuilds the town only for a
// change there: kept in lib/, the version went up for the street lamps'
// boxes (30 Oct) and the site went live with it while the town, never
// rebuilt, went on wanting the old one and turned the new walls away. The
// site reads it through lib/obstacles/walls.js.
//
// Imports nothing (the site and the town both read it).

export const WALLS = {
  version: 2026110307,   // 3 Nov: the laundrette's walls, open at its front door (wide enough for him) and its office door (lib/world/laundrette.js), after the monorail station's (2026110301)
  glb: '234616ac1d138062258ef6f96d15f388c7fa5a08',
  wants: '223503867cd2fe805c186c885cc7736b76abeac9',
  monorail: '0103959ef9849fb51a1687d1e1a392d07cb3524d',
  laundrette: 'ad2a9043bd656cc145a6888c2c36fde704cba901',
}
